<template>
    <div>
        <v-container grid-list-xl fluid>
            <StoreStepper current="payment_gateways"></StoreStepper>
            <v-form v-if="!loadingForm" class="mt-2" @submit.prevent="handleSubmit">
                <v-layout row wrap>
                    <v-flex sm12>
                        <v-card>
                            <v-widget :title="'اطلاعات درگاه' + (form.id === 0?'(افزودن)':'(ویرایش)')">
                                <div slot="widget-content">
                                    <v-container>
                                        <v-layout>
                                            <v-flex>
                                                <v-text-field
                                                        label="نام درگاه پرداخت"
                                                        name="name"
                                                        v-model="form.name"
                                                        type="text"
                                                        :rules="[rules.required]"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex>
                                                <v-autocomplete
                                                        label="نوع درگاه"
                                                        :items="drivers"
                                                        item-text="name"
                                                        item-value="short_name"
                                                        name="merchant"
                                                        @change="changeDriver($event)"
                                                        v-model="form.gateway_type"
                                                ></v-autocomplete>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout>
                                            <v-flex v-if="current_gateway.username.length > 0">
                                                <v-text-field
                                                        :label="current_gateway.username"
                                                        name="username"
                                                        data-ltr
                                                        v-model="form.username"
                                                        type="text"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex v-if="current_gateway.password.length > 0">
                                                <v-text-field
                                                        :label="current_gateway.password"
                                                        name="password"
                                                        data-ltr
                                                        v-model="form.password"
                                                        type="password"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex v-if="current_gateway.merchant_id.length > 0">
                                                <v-text-field
                                                        :label="current_gateway.merchant_id"
                                                        name="merchant"
                                                        v-model="form.merchant"
                                                        type="text"
                                                        data-ltr
                                                        :rules="[rules.required]"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout>
                                            <v-btn
                                                    :loading="loading"
                                                    type="submit"
                                                    :disabled="loading"
                                                    :color="form.id === 0?'green':'blue'"
                                                    class="white--text"
                                                    large
                                            >
                                                ذخیره
                                                &nbsp;
                                                <v-icon left dark>save</v-icon>
                                            </v-btn>
                                            <v-btn
                                                    @click.native="formReset"
                                                    color="orange"
                                                    class="white--text"
                                                    large
                                                    type="reset"
                                            >
                                                بازنشانی
                                                &nbsp;
                                                <v-icon left dark>settings_backup_restore</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </v-container>
                                </div>
                            </v-widget>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-form>
            <v-layout v-if="!loadingForm" row wrap>
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field
                                    flat
                                    solo
                                    prepend-icon="search"
                                    placeholder="جستجو..."
                                    v-model="search"
                                    hide-details
                                    class="hidden-sm-and-down"
                            ></v-text-field>
                            <v-btn icon>
                                <v-icon>filter_list</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                    :headers="complex.headers"
                                    :search="search"
                                    :items="complex.items"
                                    :rows-per-page-items="[25,50,100,500,{text:'همه','value':-1}]"
                                    class="elevation-1"
                                    item-key="id"
                                    select-all
                                    v-model="complex.selected"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-center">
                                        <v-checkbox
                                                primary
                                                hide-details
                                                v-model="props.selected"
                                        ></v-checkbox>
                                    </td>
                                    <td class="text-xs-center">{{ props.item.id }}</td>
                                    <td class="text-xs-center">{{ props.item.name }}</td>
                                    <td class="text-xs-center">{{ props.item.merchant }}</td>
                                    <td class="text-xs-center">{{ props.item.username }}</td>
                                    <td class="text-xs-center">{{ getGatewayByType(props.item.gateway_type).name }}</td>
                                    <td class="text-xs-center">
                                        <v-btn depressed outline icon fab dark color="primary"
                                               @click="goEdit(props.item.id)"
                                               small>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn depressed outline icon fab dark color="pink" small
                                               @click="DeleteGateway(props.item.id)">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-layout v-if="loadingForm" class="row wrap">
                <v-flex md12>
                    <fake-item></fake-item>
                </v-flex>
                <v-flex md12>
                    <fake-item></fake-item>
                </v-flex>
            </v-layout>
            <v-snackbar
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    :top="snackbar.y === 'top'"
                    :bottom="snackbar.y === 'bottom'"
                    :right="snackbar.x === 'right'"
                    :left="snackbar.x === 'left'"
                    :multi-line="snackbar.mode === 'multi-line'"
                    :vertical="snackbar.mode === 'vertical'"
                    v-model="snackbar.snackbar"
            >
                {{ snackbar.text }}
                <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
        </v-container>
    </div>
</template>

<script>
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
import StoreStepper from '@/components/StoreStepper';
import VWidget from '@/components/VWidget';
export default {
  components: {
    StoreStepper,
    VWidget
  },
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      loadingForm: true,
      search: '',
      complex: {
        selected: [],
        headers: [
          {
            text: 'شناسه',
            value: 'id',
            align: 'center'
          },
          {
            text: 'عنوان درگاه',
            value: 'name',
            align: 'center'
          },
          {
            text: 'مرچنت/شماره پذیرنده',
            value: 'merchant',
            align: 'center'
          },
          {
            text: 'نام کاربری',
            value: 'username',
            align: 'center'
          },
          {
            text: 'نوع درگاه',
            value: 'gateway_type',
            align: 'center'
          },

          {
            text: 'مدیریت',
            value: '',
            align: 'center'
          },
        ],
        items: []
      },
      formInit: {
        id: 0,
        store_id: 0,
        name: '',
        merchant: '',
        username: '',
        password: '',
        gateway_type: 'ZP',
      },
      form: {
        id: 0,
        store_id: 0,
        name: '',
        merchant: '',
        username: '',
        password: '',
        gateway_type: 'ZP',
      },
      current_gateway: {
        name: 'زرین پال',
        short_name: 'ZP',
        username: 'API کد',
        password: '',
        merchant_id: ''
      },
      drivers: [],
      loader: null,
      loading: false,
      rules: {
        required: (value) => !!value || 'پر کردن این فیلد اجباری است.',
      }
    };
  },
  mounted: function () {
    this.form.store_id = Number(this.$route.params.store_id);
    this.formInit.store_id = Number(this.$route.params.store_id);
    this.axios.get('/reseller/gateway_drivers/')
      .then(response => {
        this.drivers = response.data;
        this.loadingForm = false;
      }).catch(err => {
        this.snackbar = HttpErrorToSnackbar(err);
      });
    this.loadGateways();
  },
  methods: {
    getGatewayByType (type) {
      return this.drivers.find(d => d.short_name === type);
    },
    goEdit (id) {
      this.form = Object.assign({}, this.complex.items.find(i => i.id === id));
      this.current_gateway = this.getGatewayByType(this.form.gateway_type);
      window.scrollY -= 200;
    },
    loadGateways () {
      this.axios.get('/reseller/payment_gateways/')
        .then(response => {
          this.complex.items = response.data.data;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    changeDriver (driver) {
      this.current_gateway = this.drivers.find(d => d.short_name === driver);
    },
    formReset () {
      this.form = Object.assign({}, this.formInit);
    },
    handleSubmit () {
      this.$validator.validateAll().then((isValidate) => {
        if (isValidate) {
          this.loader = 'loading';
          if (this.form.id === 0) {
            this.axios.post('/reseller/payment_gateways/', this.form)
              .then(response => {
                // Response Submit Method
                console.log(response);
                this.snackbar.text = 'با موفقیت انجام شد.';
                this.snackbar.y = 'bottom';
                this.snackbar.color = 'success';
                this.snackbar.snackbar = true;
                this.loading = false;
                this.formReset();
                this.loadGateways();
              })
              .catch(error => {
                this.snackbar = HttpErrorToSnackbar(error);
                this.loading = false;
              });
          } else {
            this.axios.put('/reseller/payment_gateways/' + this.form.id, this.form)
              .then(response => {
                // Response Submit Method
                console.log(response);
                this.snackbar.text = 'با موفقیت ذخیره شد.';
                this.snackbar.y = 'bottom';
                this.snackbar.color = 'success';
                this.snackbar.snackbar = true;
                this.loading = false;
                this.formReset();
                this.loadGateways();
              })
              .catch(error => {
                this.snackbar = HttpErrorToSnackbar(error);
                this.loading = false;
              });
          }
        }
      });
    },
    DeleteGateway (id) {
      this.$confirm('آیا از حذف این مورد اطمینان دارید؟').then(res => {
        if (res) {
          this.axios.delete('/reseller/payment_gateways/' + id)
            .then(response => {
              this.snackbar.snackbar = true;
              this.snackbar.color = 'success';
              this.snackbar.text = response.data.messages.join(' ');
              this.loadGateways();
            })
            .catch(error => {
              this.snackbar = HttpErrorToSnackbar(error);
            });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/payment_gateways/modify.vue